const CART_UPSELL_SELECTOR = '[data-gb-cart-upsell-add]';

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest(CART_UPSELL_SELECTOR) : null;
  if (!(button instanceof HTMLButtonElement)) return;

  event.preventDefault();

  if (button.disabled) return;

  const variantId = button.dataset.variantId;
  const label = button.querySelector('[data-gb-cart-upsell-label]');
  const wrapper = button.closest('[data-gb-cart-upsells]');
  const error = wrapper?.querySelector('[data-gb-cart-upsell-error]');

  if (!variantId) return;

  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((component) => (component instanceof HTMLElement ? component.dataset.sectionId : ''))
    .filter(Boolean);

  button.disabled = true;
  if (label) label.textContent = '...';
  if (error instanceof HTMLElement) {
    error.hidden = true;
    error.textContent = '';
  }

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });

    const result = await response.json();

    if (!response.ok || result.status) {
      throw new Error(result.description || result.message || 'Toevoegen lukt niet. Probeer het opnieuw.');
    }

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: result,
          sourceId: 'cart-drawer-upsell',
          data: {
            source: 'cart-drawer-upsell',
            variantId,
            sections: result.sections,
          },
        },
      })
    );
  } catch (addError) {
    if (error instanceof HTMLElement) {
      error.textContent = addError instanceof Error ? addError.message : 'Toevoegen lukt niet. Probeer het opnieuw.';
      error.hidden = false;
    }

    button.disabled = false;
    if (label) label.textContent = '+';
  }
});
